export default "__VITE_ASSET__DhSqg71g__"